var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentmanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.125 0 0.0125 1.125 0.0125 2.5L0 25L5 20H22.5C23.875 20 25 18.875 25 17.5V2.5C25 1.125 23.875 0 22.5 0ZM22.5 17.5H3.9625L3.225 18.2375L2.5 18.9625V2.5H22.5V17.5ZM10.625 15H20V12.5H13.125L10.625 15ZM15.45 7.6625C15.7 7.4125 15.7 7.025 15.45 6.775L13.2375 4.5625C12.9875 4.3125 12.6 4.3125 12.35 4.5625L5 11.9125V15H8.0875L15.45 7.6625Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentmanagement);
export default __webpack_public_path__ + "static/media/contentmanagement.d0dcbc409908c83d2ebe8d6d21b627de.svg";
export { ForwardRef as ReactComponent };